import styled from 'styled-components'
import WeekdayDot from './WeekdayDot'

const Container = styled.div`
  width: 100%;
  padding: 20px 16px;
  display: flex;
  justify-content: space-between;
  background-color: ${(props) => props.theme.colors.neutral[100]};
  border-radius: 10px;
  cursor: pointer;
  // 모바일에서 터치 시 발생하는 파란색 하이라이트 제거 
  -webkit-tap-highlight-color: transparent;
`
const WeeklyCalendar = ({ weeklyCounts, selectedDay, onSelect }) => {
  return (
    <Container>
      {weeklyCounts.map((count, index) => (
        <WeekdayDot
          key={index}
          count={count}
          dayIndex={index}
          isActive={selectedDay === index}
          onClick={() => onSelect(index)}/>
      ))}
    </Container>
  )
}

export default WeeklyCalendar
